import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combine class names with clsx + tailwind-merge so that conflicting
 * Tailwind utilities collapse to the last one. Used by every component
 * in @/components/.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
